import { Grid, TextField } from "@mui/material";
import moment from "moment";
import React from "react";

const GeneralDetails = ({ sessionGeneralDetail }) => {
  console.log("huha", sessionGeneralDetail);
  const getFormattedTime = (time) => {
    if (time) {
      const formattedTime = moment(time).format("h:mm A");
      return formattedTime;
    }
    return "-";
  };
  return (
    <>
      <Grid container spacing={2} sx={{ paddingRight: "30%" }}>
        <Grid item xs={6}>
          <TextField
            size="small"
            fullWidth
            value={sessionGeneralDetail?.sessionName}
            placeholder="Session Name"
            disabled
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            size="small"
            fullWidth
            value={sessionGeneralDetail?.totalDuration ? sessionGeneralDetail?.totalDuration : "Not Available"}
            placeholder="Session Duration in hrs"
            disabled
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            size="small"
            fullWidth
            value={getFormattedTime(sessionGeneralDetail?.startDate)}
            placeholder="Start Time"
            disabled
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            size="small"
            fullWidth
            value={getFormattedTime(sessionGeneralDetail?.endDate)}
            placeholder="End Time"
            disabled
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            size="small"
            multiline
            minRows={4}
            fullWidth
            value="Not Available"
            placeholder="Session Information"
            disabled
          />
        </Grid>
      </Grid>
    </>
  );
};

export default GeneralDetails;
